import { render } from "./ChatBubble.vue?vue&type=template&id=7e70cc58&scoped=true"
import script from "./ChatBubble.vue?vue&type=script&lang=js"
export * from "./ChatBubble.vue?vue&type=script&lang=js"

import "./ChatBubble.vue?vue&type=style&index=0&id=7e70cc58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e70cc58"]])

export default __exports__